(function () {
  'use strict';

  var overlay = document.getElementById('cw-nav-overlay');
  var mobilePanel = document.getElementById('cw-mobile-panel');
  var mobileOpenBtn = document.getElementById('cw-mobile-open');
  var mobileCloseBtn = document.getElementById('cw-mobile-close');
  var cartPanel = document.getElementById('cw-cart-panel');
  var cartOpenBtns = document.querySelectorAll('[data-cw-drawer-trigger="cart"]');
  var cartCloseBtn = document.getElementById('cw-cart-close');
  var favPanel = document.getElementById('cw-fav-panel');
  var favOpenBtns = document.querySelectorAll('[data-cw-drawer-trigger="favorites"]');
  var favCloseBtn = document.getElementById('cw-fav-close');
  var favCountEls = document.querySelectorAll('.cw-fav-count');
  var favContentEl = document.getElementById('cw-fav-panel-content');
  var favFetchController = null;
  var nav = document.querySelector('.cw-primary-nav');
  var desktopDropdownItems = nav ? nav.querySelectorAll('.cw-primary-nav__item--has-dropdown') : [];
  var desktopDropdownTriggers = nav ? nav.querySelectorAll('.cw-primary-nav__item--has-dropdown > .cw-nav-link--has-dropdown') : [];
  var desktopQuery = window.matchMedia('(min-width: 1081px)');
  var activeDrawer = null;
  var drawerHistoryActive = false;
  var lastDrawerTriggers = {
    mobile: null,
    cart: null,
    favorites: null
  };
  var dropdownCloseTimer = null;
  var searchInput = document.getElementById('cw-header-search-input');
  var searchResults = document.getElementById('cw-header-search-results');
  var searchScriptLoading = false;
  var searchScriptLoaded = false;

  function isOpen() {
    return !!activeDrawer;
  }

  function getDrawerPanel(name) {
    if (name === 'mobile') {
      return mobilePanel;
    }

    if (name === 'cart') {
      return cartPanel;
    }

    if (name === 'favorites') {
      return favPanel;
    }

    return null;
  }

  function getDrawerTriggers(name) {
    if (name === 'cart') {
      return cartOpenBtns;
    }

    if (name === 'favorites') {
      return favOpenBtns;
    }

    var single = getDrawerTrigger(name);
    return single ? [single] : [];
  }

  function isVisibleFocusTarget(el) {
    if (!el || typeof el.focus !== 'function' || el.disabled || el.hidden) {
      return false;
    }
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) {
      return false;
    }
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function resolveDrawerTrigger(name) {
    var remembered = lastDrawerTriggers[name];
    if (isVisibleFocusTarget(remembered)) {
      return remembered;
    }

    if (name === 'cart') {
      for (var ci = 0; ci < cartOpenBtns.length; ci += 1) {
        if (isVisibleFocusTarget(cartOpenBtns[ci])) {
          return cartOpenBtns[ci];
        }
      }
      return cartOpenBtns.length ? cartOpenBtns[0] : null;
    }

    if (name === 'favorites') {
      for (var fi = 0; fi < favOpenBtns.length; fi += 1) {
        if (isVisibleFocusTarget(favOpenBtns[fi])) {
          return favOpenBtns[fi];
        }
      }
      return favOpenBtns.length ? favOpenBtns[0] : null;
    }

    return getDrawerTrigger(name);
  }

  function releaseDrawerFocus(panel, name) {
    if (!panel || !document.activeElement || typeof panel.contains !== 'function' || !panel.contains(document.activeElement)) {
      return;
    }

    var trigger = resolveDrawerTrigger(name);
    if (isVisibleFocusTarget(trigger)) {
      try {
        trigger.focus({ preventScroll: true });
      } catch (errFocus) {
        trigger.focus();
      }
      return;
    }

    if (document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  function rememberDrawerTrigger(name, el) {
    if (el) {
      lastDrawerTriggers[name] = el;
    }
  }

  function getDrawerTrigger(name) {
    if (name === 'mobile') {
      return mobileOpenBtn;
    }

    if (name === 'cart') {
      return cartOpenBtns.length ? cartOpenBtns[0] : null;
    }

    if (name === 'favorites') {
      return favOpenBtns.length ? favOpenBtns[0] : null;
    }

    return null;
  }

  function closeDropdown(item) {
    if (!item) {
      return;
    }
    item.classList.remove('cw-primary-nav__item--open');
    var trigger = item.querySelector('.cw-nav-link--has-dropdown');
    var dropdown = item.querySelector('.cw-nm-mega');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
    if (dropdown) {
      dropdown.setAttribute('aria-hidden', 'true');
    }
  }

  function clearDropdownCloseTimer() {
    if (dropdownCloseTimer) {
      clearTimeout(dropdownCloseTimer);
      dropdownCloseTimer = null;
    }
  }

  function scheduleDropdownClose() {
    clearDropdownCloseTimer();
    dropdownCloseTimer = setTimeout(function () {
      closeAllDropdowns();
    }, 140);
  }

  function closeAllDropdowns(exceptItem) {
    for (var i = 0; i < desktopDropdownItems.length; i += 1) {
      if (desktopDropdownItems[i] !== exceptItem) {
        closeDropdown(desktopDropdownItems[i]);
      }
    }
  }

  function isMegaPairItem(item) {
    return !!(item && item.getAttribute('data-cw-mega-pair') === '1');
  }

  function openDropdown(item) {
    if (!item) {
      return;
    }
    clearDropdownCloseTimer();
    var prevOpen = nav ? nav.querySelector('.cw-primary-nav__item--open') : null;
    var instantSwap =
      !!nav &&
      prevOpen &&
      prevOpen !== item &&
      isMegaPairItem(prevOpen) &&
      isMegaPairItem(item);
    if (instantSwap) {
      nav.classList.add('cw-primary-nav--mega-instant');
    }
    closeAllDropdowns(item);
    item.classList.add('cw-primary-nav__item--open');
    var trigger = item.querySelector('.cw-nav-link--has-dropdown');
    var dropdown = item.querySelector('.cw-nm-mega');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
    if (dropdown) {
      dropdown.setAttribute('aria-hidden', 'false');
    }
    if (instantSwap && nav) {
      void nav.offsetWidth;
      nav.classList.remove('cw-primary-nav--mega-instant');
    }
  }

  function bindDesktopDropdownHover(item) {
    if (!item) {
      return;
    }

    item.addEventListener('mouseenter', function () {
      if (!desktopQuery.matches) {
        return;
      }
      clearDropdownCloseTimer();
      openDropdown(item);
    });
  }

  function applyDrawerState(name, open) {
    var panel = getDrawerPanel(name);

    if (!panel || !overlay) {
      return;
    }

    if (!open) {
      releaseDrawerFocus(panel, name);
    }

    panel.setAttribute('data-open', open ? '1' : '0');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.classList.toggle('cw-nav-overlay--visible', open || (activeDrawer !== null && activeDrawer !== name));
    overlay.setAttribute('aria-hidden', activeDrawer ? 'false' : 'true');
    document.body.classList.toggle('cw-nav-open', !!activeDrawer);
    var triggers = getDrawerTriggers(name);
    for (var ti = 0; ti < triggers.length; ti += 1) {
      triggers[ti].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function closeCurrentDrawer(syncHistory) {
    if (!activeDrawer) {
      return;
    }

    var currentDrawer = activeDrawer;
    if (drawerHistoryActive && syncHistory !== false && window.history && window.history.back) {
      window.history.back();
      return;
    }

    activeDrawer = null;
    applyDrawerState(currentDrawer, false);
  }

  function openDrawer(name) {
    var panel = getDrawerPanel(name);
    if (!panel || !overlay) {
      return;
    }

    if (activeDrawer === name) {
      return;
    }

    if (activeDrawer) {
      applyDrawerState(activeDrawer, false);
    }

    activeDrawer = name;

    if (!drawerHistoryActive && window.history && window.history.pushState) {
      window.history.pushState({ cwDrawerOpen: name }, '', window.location.href);
      drawerHistoryActive = true;
    }

    applyDrawerState(name, true);

    if (name === 'favorites') {
      loadFavoritesPanel();
    }

    if (name !== 'mobile') {
      closeAllDropdowns();
    }
  }

  function toggleDrawer(name) {
    if (activeDrawer === name) {
      closeCurrentDrawer();
      return;
    }

    openDrawer(name);
  }

  for (var i = 0; i < desktopDropdownTriggers.length; i += 1) {
    desktopDropdownTriggers[i].setAttribute('aria-haspopup', 'true');
    desktopDropdownTriggers[i].setAttribute('aria-expanded', 'false');
    desktopDropdownTriggers[i].addEventListener('click', function (e) {
      if (!desktopQuery.matches) {
        return;
      }

      var item = this.closest('.cw-primary-nav__item--has-dropdown');
      if (!item) {
        return;
      }

      e.preventDefault();
      if (item.classList.contains('cw-primary-nav__item--open')) {
        closeDropdown(item);
        return;
      }

      openDropdown(item);
    });
  }

  for (var j = 0; j < desktopDropdownItems.length; j += 1) {
    bindDesktopDropdownHover(desktopDropdownItems[j]);
  }

  if (nav) {
    // Zamknij mega przy najechaniu na zwykłe pozycje (Projektuj sam, O nas, Kontakt…)
    var desktopNavPlainItems = nav.querySelectorAll(
      '.cw-nm-nav__item:not(.cw-primary-nav__item--has-dropdown)'
    );
    for (var pi = 0; pi < desktopNavPlainItems.length; pi += 1) {
      desktopNavPlainItems[pi].addEventListener('mouseenter', function () {
        if (!desktopQuery.matches) {
          return;
        }
        clearDropdownCloseTimer();
        closeAllDropdowns();
      });
    }

    nav.addEventListener('mouseenter', function () {
      if (!desktopQuery.matches) {
        return;
      }
      clearDropdownCloseTimer();
    });

    nav.addEventListener('mouseleave', function () {
      if (!desktopQuery.matches) {
        return;
      }
      scheduleDropdownClose();
    });
  }

  if (mobileOpenBtn) {
    mobileOpenBtn.addEventListener('click', function () {
      rememberDrawerTrigger('mobile', mobileOpenBtn);
      toggleDrawer('mobile');
    });
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', function () {
      closeCurrentDrawer();
    });
  }

  // Accordion w drawerze mobile (Kolekcja / Sklep)
  var drawerToggles = document.querySelectorAll('[data-cw-drawer-toggle]');
  for (var dt = 0; dt < drawerToggles.length; dt += 1) {
    drawerToggles[dt].addEventListener('click', function () {
      var item = this.closest('.cw-nm-drawer__item');
      if (!item) {
        return;
      }
      var open = item.classList.toggle('is-open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  for (var ci = 0; ci < cartOpenBtns.length; ci += 1) {
    cartOpenBtns[ci].addEventListener('click', function (e) {
      if (!cartPanel) {
        return;
      }
      e.preventDefault();
      rememberDrawerTrigger('cart', this);
      toggleDrawer('cart');
    });
  }

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', function () {
      closeCurrentDrawer();
    });
  }

  document.addEventListener('cw:open-cart-drawer', function () {
    if (!cartPanel) {
      return;
    }
    rememberDrawerTrigger('cart', cartOpenBtns.length ? cartOpenBtns[0] : null);
    if (cartPanel.getAttribute('data-open') !== '1') {
      toggleDrawer('cart');
    }
  });

  for (var fi = 0; fi < favOpenBtns.length; fi += 1) {
    favOpenBtns[fi].addEventListener('click', function (e) {
      if (!favPanel) {
        return;
      }
      e.preventDefault();
      rememberDrawerTrigger('favorites', this);
      toggleDrawer('favorites');
    });
  }

  if (favCloseBtn) {
    favCloseBtn.addEventListener('click', function () {
      closeCurrentDrawer();
    });
  }

  function readFavoriteIds() {
    if (window.CustomWearFavorites && typeof window.CustomWearFavorites.read === 'function') {
      return window.CustomWearFavorites.read();
    }
    return [];
  }

  function removeFavoriteId(productId) {
    var id = String(productId);
    if (window.CustomWearFavorites && typeof window.CustomWearFavorites.write === 'function') {
      var favs = readFavoriteIds().filter(function (fid) {
        return String(fid) !== id;
      });
      window.CustomWearFavorites.write(favs);
      return;
    }
    try {
      var raw = localStorage.getItem('cw_favorites');
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) {
        return;
      }
      var next = parsed.filter(function (fid) {
        return String(fid) !== id;
      });
      localStorage.setItem('cw_favorites', JSON.stringify(next));
      window.dispatchEvent(new CustomEvent('cw:favorites-changed', { detail: { ids: next } }));
    } catch (err) {
      /* ignore */
    }
  }

  function pruneStaleFavoriteIds(requestedIds, validItems) {
    if (!requestedIds || !requestedIds.length) {
      return;
    }
    var validSet = {};
    (validItems || []).forEach(function (item) {
      if (item && item.id) {
        validSet[String(item.id)] = true;
      }
    });
    var hasStale = requestedIds.some(function (id) {
      return !validSet[String(id)];
    });
    if (!hasStale) {
      return;
    }
    var requestedSet = {};
    requestedIds.forEach(function (id) {
      requestedSet[String(id)] = true;
    });
    var next = readFavoriteIds().filter(function (fid) {
      if (!requestedSet[String(fid)]) {
        return true;
      }
      return !!validSet[String(fid)];
    });
    if (window.CustomWearFavorites && typeof window.CustomWearFavorites.write === 'function') {
      window.CustomWearFavorites.write(next);
    }
  }

  function fetchFavoriteItems(ids) {
    var cfg = window.customwearHeader || {};
    var ajaxUrl = cfg.ajaxUrl || '/wp-admin/admin-ajax.php';
    var action = cfg.favoritesAction || 'customwear_favorites_products';
    var url = ajaxUrl + '?action=' + encodeURIComponent(action) + '&ids=' + encodeURIComponent(ids.join(','));
    var fetchOpts = { credentials: 'same-origin' };
    return fetch(url, fetchOpts).then(function (res) {
      return res.json();
    });
  }

  function validateFavoritesStorage() {
    var ids = readFavoriteIds();
    syncFavCountBadge();
    if (!ids.length) {
      return;
    }
    fetchFavoriteItems(ids)
      .then(function (payload) {
        if (!payload || !payload.success) {
          return;
        }
        var items = payload.data && payload.data.items ? payload.data.items : [];
        pruneStaleFavoriteIds(ids, items);
        syncFavCountBadge();
      })
      .catch(function () {
        /* ignore */
      });
  }

  function formatFavCount(count) {
    if (count > 99) {
      return '99+';
    }
    return String(count);
  }

  function syncFavCountBadge() {
    if (!favCountEls.length) {
      return;
    }
    var count = readFavoriteIds().length;
    for (var i = 0; i < favCountEls.length; i += 1) {
      var el = favCountEls[i];
      if (count <= 0) {
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
        el.textContent = '0';
      } else {
        el.hidden = false;
        el.removeAttribute('aria-hidden');
        el.textContent = formatFavCount(count);
      }
    }
  }

  function renderFavoritesEmpty() {
    if (!favContentEl) {
      return;
    }
    favContentEl.innerHTML =
      '<p class="cw-fav-panel__empty">Brak ulubionych produktów.</p>';
  }

  function renderFavoritesItems(items) {
    if (!favContentEl) {
      return;
    }
    if (!items || !items.length) {
      renderFavoritesEmpty();
      return;
    }

    var html = '<ul class="cw-fav-panel__list">';
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var thumbInner = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" decoding="async" width="64" height="80">'
        : '';
      html +=
        '<li class="cw-fav-panel__item" data-cw-fav-item="' + escapeHtml(String(item.id)) + '">' +
        '<a class="cw-fav-panel__thumb" href="' + escapeHtml(item.url) + '">' +
        '<span class="cw-fav-panel__thumb-frame' + (thumbInner ? '' : ' cw-fav-panel__thumb-frame--empty') + '">' +
        thumbInner +
        '</span>' +
        '</a>' +
        '<div class="cw-fav-panel__body">' +
        '<a class="cw-fav-panel__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.name) + '</a>' +
        '<p class="cw-fav-panel__price">' + (item.price || '') + '</p>' +
        '</div>' +
        '<button type="button" class="cw-fav-panel__remove" data-cw-fav-remove="' + escapeHtml(String(item.id)) + '" aria-label="Usuń z ulubionych">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '</li>';
    }
    html += '</ul>';
    favContentEl.innerHTML = html;
  }

  function loadFavoritesPanel() {
    if (!favContentEl) {
      return;
    }

    var ids = readFavoriteIds();
    if (!ids.length) {
      renderFavoritesEmpty();
      return;
    }

    favContentEl.innerHTML = '<p class="cw-fav-panel__loading">Ładowanie…</p>';

    if (favFetchController) {
      favFetchController.abort();
    }
    favFetchController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var fetchOpts = { credentials: 'same-origin' };
    if (favFetchController) {
      fetchOpts.signal = favFetchController.signal;
    }

    var cfg = window.customwearHeader || {};
    var ajaxUrl = cfg.ajaxUrl || '/wp-admin/admin-ajax.php';
    var action = cfg.favoritesAction || 'customwear_favorites_products';
    var url = ajaxUrl + '?action=' + encodeURIComponent(action) + '&ids=' + encodeURIComponent(ids.join(','));

    fetch(url, fetchOpts)
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (!payload || !payload.success) {
          renderFavoritesEmpty();
          return;
        }
        var items = payload.data && payload.data.items ? payload.data.items : [];
        pruneStaleFavoriteIds(ids, items);
        syncFavCountBadge();
        renderFavoritesItems(items);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') {
          return;
        }
        renderFavoritesEmpty();
      });
  }

  if (favContentEl) {
    favContentEl.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cw-fav-remove]');
      if (!btn) {
        return;
      }
      e.preventDefault();
      var pid = btn.getAttribute('data-cw-fav-remove');
      if (!pid) {
        return;
      }
      removeFavoriteId(pid);
      var row = btn.closest('[data-cw-fav-item]');
      if (row) {
        row.remove();
      }
      if (!favContentEl.querySelector('[data-cw-fav-item]')) {
        renderFavoritesEmpty();
      }
    });
  }

  window.addEventListener('cw:favorites-changed', function () {
    syncFavCountBadge();
    if (activeDrawer === 'favorites') {
      loadFavoritesPanel();
    }
  });

  syncFavCountBadge();
  validateFavoritesStorage();

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeCurrentDrawer();
    });
  }

  document.addEventListener('click', function (e) {
    if (!desktopQuery.matches || !nav) {
      return;
    }

    if (!nav.contains(e.target)) {
      closeAllDropdowns();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCurrentDrawer();
      closeAllDropdowns();
    }
  });

  window.addEventListener('popstate', function () {
    if (activeDrawer) {
      var drawer = activeDrawer;
      drawerHistoryActive = false;
      activeDrawer = null;
      applyDrawerState(drawer, false);
    }
  });

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function loadHeaderSearchModule(callback) {
    if (searchScriptLoaded && typeof window.customwearInitHeaderSearch === 'function') {
      callback();
      return;
    }

    if (searchScriptLoading) {
      document.addEventListener('customwear:search-ready', callback, { once: true });
      return;
    }

    var scriptUrl = window.customwearHeader && window.customwearHeader.searchScriptUrl;
    if (!scriptUrl) {
      return;
    }

    searchScriptLoading = true;
    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = function () {
      searchScriptLoaded = true;
      searchScriptLoading = false;
      if (typeof window.customwearInitHeaderSearch === 'function') {
        window.customwearInitHeaderSearch();
      }
      document.dispatchEvent(new CustomEvent('customwear:search-ready'));
      callback();
    };
    script.onerror = function () {
      searchScriptLoading = false;
    };
    document.head.appendChild(script);
  }

  function bindLazyHeaderSearch(inputEl) {
    if (!inputEl) {
      return;
    }

    function boot() {
      loadHeaderSearchModule(function () {
        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    inputEl.addEventListener('focus', boot, { once: true });
    inputEl.addEventListener('input', boot, { once: true });
  }

  bindLazyHeaderSearch(searchInput);
  bindLazyHeaderSearch(document.getElementById('cw-header-search-input-mobile'));

  /* ── Galeria produktu ── */
  var mqGalleryDesktop = window.matchMedia('(min-width: 901px)');
  var mqGalleryMobile = window.matchMedia('(max-width: 900px)');

  function openProductLightbox(urls, alts, startIndex) {
    if (window.CustomWearProductLightbox && typeof window.CustomWearProductLightbox.open === 'function') {
      window.CustomWearProductLightbox.open(urls, alts, startIndex);
      return;
    }
    window.open(urls[startIndex] || urls[0], '_blank', 'noopener');
  }

  function updateGalleryOverflow(gallery) {
    var col = gallery.querySelector('[data-thumbs-col]');
    var thumbs = gallery.querySelector('[data-thumbs]');
    var downBtn = gallery.querySelector('[data-gallery-down]');
    if (!col || !thumbs || !downBtn) {
      return;
    }
    if (!mqGalleryDesktop.matches) {
      downBtn.hidden = true;
      col.removeAttribute('data-overflow');
      return;
    }
    var overflow = thumbs.scrollHeight > thumbs.clientHeight + 2;
    col.setAttribute('data-overflow', overflow ? '1' : '0');
    downBtn.hidden = !overflow;
  }

  function galleryActiveIndex(slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i].classList.contains('is-active')) {
        return Number(slides[i].getAttribute('data-slide'));
      }
    }
    return 0;
  }

  function primeGallerySlideImage(slide) {
    if (!slide) {
      return;
    }
    var img = slide.querySelector('.cw-product-gallery__img');
    if (!img) {
      return;
    }
    img.loading = 'eager';
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) {
      var zoom = slide.querySelector('.cw-product-gallery__zoom');
      if (zoom) {
        var full = zoom.getAttribute('data-full-src') || zoom.href || '';
        if (full) {
          img.src = full;
          src = full;
        }
      }
    }
    if (src && !img.complete && typeof img.decode === 'function') {
      img.decode().catch(function () {});
    }
  }

  var galleries = document.querySelectorAll('[data-gallery]');
  for (var g = 0; g < galleries.length; g += 1) {
    (function (gallery) {
      var thumbsTrack = gallery.querySelector('[data-thumbs]');
      var downBtn = gallery.querySelector('[data-gallery-down]');
      var stage = gallery.querySelector('[data-stage]');
      var mainEl = gallery.querySelector('.cw-product-gallery__main');
      var curSpan = gallery.querySelector('[data-gallery-current]');
      var swipeBlockClick = false;

      function gallerySlides() {
        return gallery.querySelectorAll('[data-slide]');
      }

      function galleryThumbs() {
        return gallery.querySelectorAll('button[data-thumb]');
      }

      function slideIsVisible(slide) {
        return slide && !slide.hidden;
      }

      function visibleSlideOrder() {
        var order = [];
        gallerySlides().forEach(function (slide) {
          if (!slideIsVisible(slide)) {
            return;
          }
          var idx = Number(slide.getAttribute('data-slide'));
          if (Number.isFinite(idx)) {
            order.push(idx);
          }
        });
        return order;
      }

      function updateGalleryCounter(activeIdx, visibleOrder) {
        var totalEl = gallery.querySelector('[data-gallery-total]');
        var counter = gallery.querySelector('[data-gallery-counter]');
        if (!visibleOrder || visibleOrder.length === 0) {
          visibleOrder = visibleSlideOrder();
        }
        if (counter) {
          counter.hidden = visibleOrder.length <= 1;
        }
        if (totalEl) {
          totalEl.textContent = String(Math.max(visibleOrder.length, 1));
        }
        if (curSpan) {
          var pos = visibleOrder.indexOf(activeIdx);
          curSpan.textContent = String(pos >= 0 ? pos + 1 : 1);
        }
      }

      function clearDesktopZoom() {
        if (!stage) {
          return;
        }
        stage.classList.remove('is-zooming');
        var layer = stage.querySelector('[data-cw-zoom-layer]');
        if (layer) {
          layer.style.backgroundImage = '';
          layer.style.backgroundPosition = '50% 50%';
        }
        var zActive = stage.querySelector('.cw-product-gallery__zoom[aria-pressed="true"]');
        if (zActive) {
          zActive.setAttribute('aria-pressed', 'false');
        }
      }

      function ensureZoomLayer() {
        if (!stage) {
          return null;
        }
        var layer = stage.querySelector('[data-cw-zoom-layer]');
        if (layer) {
          return layer;
        }
        layer = document.createElement('div');
        layer.className = 'cw-product-gallery__zoom-layer';
        layer.setAttribute('data-cw-zoom-layer', '');
        layer.setAttribute('aria-hidden', 'true');
        stage.appendChild(layer);
        return layer;
      }

      function zoomImageSrc(zoomBtn) {
        if (!zoomBtn) {
          return '';
        }
        var full = zoomBtn.getAttribute('data-full-src') || '';
        if (full) {
          return full;
        }
        var img = zoomBtn.querySelector('img');
        return img ? img.currentSrc || img.getAttribute('src') || '' : '';
      }

      function setZoomPosition(e) {
        if (!stage || !stage.classList.contains('is-zooming')) {
          return;
        }
        var layer = stage.querySelector('[data-cw-zoom-layer]');
        if (!layer) {
          return;
        }
        var rect = stage.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) {
          return;
        }
        var x = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        var y = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
        layer.style.backgroundPosition = (x * 100).toFixed(2) + '% ' + (y * 100).toFixed(2) + '%';
      }

      function enableDesktopZoom(zoomBtn, e) {
        var layer = ensureZoomLayer();
        var src = zoomImageSrc(zoomBtn);
        if (!layer || !src) {
          return;
        }
        layer.style.backgroundImage = 'url("' + String(src).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")';
        layer.style.backgroundSize = '250%';
        stage.classList.add('is-zooming');
        zoomBtn.setAttribute('aria-pressed', 'true');
        if (e) {
          setZoomPosition(e);
        } else {
          layer.style.backgroundPosition = '50% 50%';
        }
      }

      function goTo(idx, opts) {
        opts = opts || {};
        clearDesktopZoom();
        var slides = gallerySlides();
        var thumbs = galleryThumbs();
        var total = slides.length;
        if (total < 1) {
          return;
        }
        var next = ((idx % total) + total) % total;
        var order = visibleSlideOrder();
        if (opts.respectVisible !== false && order.length > 0 && order.indexOf(next) === -1) {
          next = order[0];
        }
        for (var s = 0; s < slides.length; s += 1) {
          var slideIdx = Number(slides[s].getAttribute('data-slide'));
          var isActive = slideIdx === next;
          slides[s].classList.toggle('is-active', isActive);
          if (isActive) {
            primeGallerySlideImage(slides[s]);
          }
        }
        for (var t = 0; t < thumbs.length; t += 1) {
          var thumbIdx = Number(thumbs[t].getAttribute('data-thumb'));
          var thumbActive = thumbIdx === next;
          thumbs[t].classList.toggle('is-active', thumbActive);
          thumbs[t].classList.toggle('active', thumbActive);
        }
        updateGalleryCounter(next, order);
        if (thumbsTrack) {
          var active = thumbsTrack.querySelector('.cw-product-gallery__thumb.is-active:not([hidden])');
          if (active && typeof active.scrollIntoView === 'function') {
            active.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
        updateGalleryOverflow(gallery);
      }

      function goToRelative(delta) {
        var order = visibleSlideOrder();
        if (order.length < 2) {
          return;
        }
        var cur = galleryActiveIndex(gallerySlides());
        var pos = order.indexOf(cur);
        if (pos < 0) {
          pos = 0;
        }
        var nextPos = (pos + delta + order.length) % order.length;
        goTo(order[nextPos], { respectVisible: false });
      }

      gallery.cwFilterByColor = function (indices) {
        var slides = gallerySlides();
        var thumbs = galleryThumbs();
        var allowed = null;
        if (Array.isArray(indices)) {
          allowed = new Set(indices.map(Number));
        }

        slides.forEach(function (slide) {
          var slideIdx = Number(slide.getAttribute('data-slide'));
          var show = !allowed || allowed.has(slideIdx);
          slide.hidden = !show;
          if (!show) {
            slide.classList.remove('is-active');
          }
        });

        thumbs.forEach(function (btn) {
          var thumbIdx = Number(btn.getAttribute('data-thumb'));
          var show = !allowed || allowed.has(thumbIdx);
          btn.hidden = !show;
          if (!show) {
            btn.classList.remove('is-active');
            btn.classList.remove('active');
          }
        });

        var thumbsCol = gallery.querySelector('[data-thumbs-col]');
        if (thumbsCol) {
          var singleView = !!(allowed && allowed.size <= 1);
          thumbsCol.hidden = false;
          thumbsCol.classList.toggle('cw-product-gallery__thumbs-col--spacer', singleView);
        }

        gallery.classList.toggle('cw-product-gallery--single', !!(allowed && allowed.size <= 1));

        var order = visibleSlideOrder();
        if (order.length > 0) {
          goTo(order[0], { respectVisible: false });
        } else {
          updateGalleryCounter(0, order);
        }
        updateGalleryOverflow(gallery);
      };

      if (thumbsTrack) {
        thumbsTrack.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('button[data-thumb]');
          if (!btn || !thumbsTrack.contains(btn)) {
            return;
          }
          e.preventDefault();
          var thumbIdx = Number(btn.getAttribute('data-thumb'));
          if (!Number.isFinite(thumbIdx)) {
            return;
          }
          goTo(thumbIdx);
        });
      }

      gallery.addEventListener('click', function (e) {
        var z = e.target.closest && e.target.closest('.cw-product-gallery__zoom');
        if (!z || !gallery.contains(z)) {
          return;
        }
        e.preventDefault();

        /* Desktop — zoom na hover; klik nic nie psuje */
        if (window.matchMedia('(min-width: 901px)').matches) {
          return;
        }

        /* Mobile — lightbox */
        var zoomLinks = gallery.querySelectorAll('.cw-product-gallery__slide:not([hidden]) .cw-product-gallery__zoom');
        var urls = [];
        var alts = [];
        var clickedIdx = 0;
        for (var zi = 0; zi < zoomLinks.length; zi += 1) {
          urls.push(zoomLinks[zi].getAttribute('data-full-src') || '');
          var gim = zoomLinks[zi].querySelector('img');
          alts.push(gim ? gim.getAttribute('alt') || '' : '');
          if (zoomLinks[zi] === z) {
            clickedIdx = zi;
          }
        }
        openProductLightbox(urls, alts, clickedIdx);
      });

      if (stage) {
        stage.addEventListener('mouseenter', function (e) {
          if (!window.matchMedia('(min-width: 901px)').matches) {
            return;
          }
          var z = stage.querySelector('.cw-product-gallery__slide.is-active .cw-product-gallery__zoom');
          if (!z) {
            return;
          }
          enableDesktopZoom(z, e);
        });

        stage.addEventListener('mousemove', function (e) {
          if (!window.matchMedia('(min-width: 901px)').matches) {
            return;
          }
          if (!stage.classList.contains('is-zooming')) {
            var z = stage.querySelector('.cw-product-gallery__slide.is-active .cw-product-gallery__zoom');
            if (z) {
              enableDesktopZoom(z, e);
            }
            return;
          }
          setZoomPosition(e);
        });

        stage.addEventListener('mouseleave', function () {
          clearDesktopZoom();
        });
      }

      if (downBtn && thumbsTrack) {
        downBtn.addEventListener('click', function () {
          thumbsTrack.scrollBy({ top: Math.min(100, Math.floor(thumbsTrack.clientHeight * 0.45)), behavior: 'smooth' });
        });
      }

      if (thumbsTrack) {
        thumbsTrack.addEventListener('scroll', function () {
          updateGalleryOverflow(gallery);
        });
      }

      if (mainEl && stage && gallerySlides().length > 1) {
        mainEl.addEventListener('click', function (e) {
          if (swipeBlockClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }

      if (stage && gallerySlides().length > 1) {
        var startX = 0;
        var startY = 0;
        stage.addEventListener(
          'touchstart',
          function (e) {
            if (!mqGalleryMobile.matches || !e.changedTouches || !e.changedTouches[0]) {
              return;
            }
            startX = e.changedTouches[0].clientX;
            startY = e.changedTouches[0].clientY;
          },
          { passive: true }
        );
        stage.addEventListener(
          'touchend',
          function (e) {
            if (!mqGalleryMobile.matches || !e.changedTouches || !e.changedTouches[0]) {
              return;
            }
            var dx = e.changedTouches[0].clientX - startX;
            var dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) {
              return;
            }
            swipeBlockClick = true;
            window.setTimeout(function () {
              swipeBlockClick = false;
            }, 400);
            var cur = galleryActiveIndex(gallerySlides());
            if (dx < 0) {
              goToRelative(1);
            } else {
              goToRelative(-1);
            }
          },
          { passive: true }
        );
      }

      function onResizeGallery() {
        updateGalleryOverflow(gallery);
      }

      window.addEventListener('resize', onResizeGallery);

      if (mqGalleryDesktop.addEventListener) {
        mqGalleryDesktop.addEventListener('change', onResizeGallery);
      }

      updateGalleryOverflow(gallery);
      gallerySlides().forEach(function (slide) {
        primeGallerySlideImage(slide);
      });
      window.requestAnimationFrame(function () {
        updateGalleryOverflow(gallery);
      });
      gallery.cwGoToSlide = goTo;
    }(galleries[g]));
  }

})();
